import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sortBy } from 'lodash';
import { useAnalytics } from 'use-analytics';
import { hotelSearchRequest, setHotelTripSearchInputs } from '../../../../../store/slices/tripSearch';
import { hotelSearch } from '../../../../../store/slices/hotel';
import MultiSelectAutocompleteFilter from '../../../../Filters/MultiSelectAutocompleteFilter';

const HotelAmenitiesFilter = ({ tripId, variant, filterSpacingClass }) => {
  const isHotelTripSearch = !tripId;
  const {
    searchObj = {},
  } = useSelector((store) => store.hotel.hotelSearches[tripId] || {});
  const searchStateHotelAmenities = useSelector((store) => (!isHotelTripSearch
    ? (store.hotel.hotelSearches[tripId] || {}).amenitiesResults : store.tripSearch.searchResult
        && (store.tripSearch.searchResult.filters || {}).amenities));
  const [hotelAmenities, setHotelAmenities] = useState(null);
  const dispatch = useDispatch();
  const { track } = useAnalytics();
  const hotelTripSearchInputs = useSelector((store) => store.tripSearch.searchInputs.hotel);
  const value = isHotelTripSearch
    ? hotelTripSearchInputs.filterAmenities : searchObj.filterAmenities;
  const handleChange = (newValue) => {
    const payload = {
      tripId,
      searchObj: {
        page: 1,
        filterAmenities: newValue,
        hasFilterApplied: true,
      },
    };
    if (isHotelTripSearch) {
      dispatch(setHotelTripSearchInputs({ ...payload.searchObj }));
      dispatch(hotelSearchRequest(payload.searchObj));
    } else {
      dispatch(hotelSearch(payload));
    }
    track('hotelAmenitiesFilter.handleChange', {
      filterAmenities: JSON.stringify(newValue),
    });
  };
  useEffect(() => {
    if (searchStateHotelAmenities) {
      setHotelAmenities([{
        suggests: sortBy(searchStateHotelAmenities
          .map((item) => ({
            value: item,
            label: item,
          })), ['label']),
        label: 'Hotel Amenities',
        value: 'hotelAmenties',
      }]);
    }
  }, [searchStateHotelAmenities]);
  return (
    hotelAmenities && hotelAmenities.length > 0
      ? (
        <MultiSelectAutocompleteFilter
          onChange={handleChange}
          label="Filter by Amenities"
          options={hotelAmenities}
          values={value}
          filterMaxWidthClass="max-w-full"
          variant={variant}
          filterSpacingClass={filterSpacingClass}
          bgClassName={!isHotelTripSearch ? '' : undefined}
          freeSolo={false}
          openOnFocus
        />
      ) : <></>
  );
};
HotelAmenitiesFilter.propTypes = {
  tripId: PropTypes.string,
  variant: PropTypes.string,
  filterSpacingClass: PropTypes.string,
};
HotelAmenitiesFilter.defaultProps = {
  tripId: undefined,
  variant: 'outline',
  filterSpacingClass: undefined,
};
export default HotelAmenitiesFilter;
